import React from 'react';

export enum ModelTypes {
  VISION,
  NO_VISION,
}

export interface IModel {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
  modelType: ModelTypes;
  isThinkingModel: boolean;
  isDefaultModel: boolean;
  order: number;
  hasDynamicThinking?: boolean;
  isHarmonicModel?: boolean;
}

interface SupportedExtensions {
  image: string[];
  document: string[];
}

export const modelSupportedExtensionsMap: Record<ModelTypes, SupportedExtensions> = {
  [ModelTypes.VISION]: {
    image: ['.jpg', '.jpeg', '.png', '.heic'],
    document: ['.pdf', '.txt', '.docx', '.csv', '.xlsx', '.pptx', '.json', '.html', '.vsdx'],
  },
  [ModelTypes.NO_VISION]: {
    image: [],
    document: ['.pdf', '.txt', '.docx', '.csv', '.xlsx', '.pptx', '.json', '.html', '.vsdx'],
  },
};

export const allSupportedImageExtensions = [
  ...modelSupportedExtensionsMap[ModelTypes.VISION].image,
  ...modelSupportedExtensionsMap[ModelTypes.NO_VISION].image,
];

export const VECTORIZE_EXCLUDE_EXTENSIONS = ['xlsx', 'csv', 'json', 'vsdx'];
  
export interface TranscribeAudioToTextResponse {
  text: string
  language: string
  languageConfidence: number
  duration: number
}
